export const wrapper = () => ({
    padding: '24px 30px 32px',
});
